import PropTypes from 'prop-types';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import { API_DOMAIN } from "../../../../core/config/env";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import { exportarRecargosHorasExtras } from '../../services/informes-service';

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormExportarRecargosHorasExtras = ({ modalState }) => {

    const onSubmit = async (data) => {
        const resp = await exportarRecargosHorasExtras(
            data.fecha_inicial,
            data.fecha_final
        );
        if (!resp.status) return toast.error(resp.message);

        window.open(`${API_DOMAIN}/${resp.data}`, "_blank").focus();
        modalState.close();
    };

    const defaultValues = {
        fecha_inicial: "",
        fecha_final: "",
    };

    const form = useForm({ defaultValues });

    return (
        <FormModal
            size="lg"
            form={form}
            onSubmit={onSubmit}
            isOpen={modalState.show}
            id="formExportarRecargosHorasExtras"
            headerTitle="Exportar Informe Recargos - Horas Extras"
            closeModal={() => modalState.close()}
        >
            <Row>
                <Col sm={6}>
                    <InputController
                        name="fecha_inicial"
                        label="Fecha Inicio"
                        type="date"
                        errors={form.formState.errors}
                        control={form.control}
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        name="fecha_final"
                        label="Fecha Fin"
                        type="date"
                        errors={form.formState.errors}
                        control={form.control}
                        rules={REQUIRED_RULE}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormExportarRecargosHorasExtras.propTypes = {
    modalState: PropTypes.object,
}

export default FormExportarRecargosHorasExtras;
